import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
//全局变量
const state = {
  //页面加载时
  pageLoading: false,
  //数据加载时
  dataLoading: false,
  //当前页面路径
  path: '',
  //路由命名
  pathName: '',
  // direction: '',
  // includePage: ''
}
//数据处理
const mutations = { //触发状态
  //取出缓存数据
  setCacheData(state) {
    for (var item of cacheNameList) {
      let getData = sessionStorage.getItem(item);
      if (getData) {
        state[item] = JSON.parse(getData);
      }
    }
  },
  //页面加载时
  setPageLoading(state, payload) {
    state.pageLoading = payload;
  },
  //数据加载时
  setDataLoading(state, payload) {
    state.dataLoading = payload;
  },
  //当前页面路径
  setPath(state, payload) {
    state.path = payload;
  },
  //当前页面路径名称
  setName(state, payload) {
    state.pathName = payload;
  },
}
//提示框
var repeat = '';
Vue.prototype.prompt = function (text, time) {
  if (text == repeat) {
    return false;
  }
  repeat = text;
  var time = time || 3000;
  var htm = document.createElement('div');
  htm.innerHTML = text;
  htm.setAttribute('class', "prompt");
  document.body.appendChild(htm);
  setTimeout(() => {
    deletes(htm);
    repeat = '';
  }, time);

  function deletes(htm) {
    htm.style.opacity = 0;
    htm.style.top = htm.offsetTop - 80 + 'px';
    setTimeout(() => {
      document.body.removeChild(htm);
    }, 600)
  }
}
//异步处理
const actions = {
}
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions
})




// WEBPACK FOOTER //
// ./src/config/store.js